import { ProFormColorPicker } from '@ant-design/pro-components'
import type React from 'react'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export type ColorPickerFieldProps = React.ComponentProps<typeof ProFormColorPicker>

export function ColorPickerField(props: ColorPickerFieldProps) {
  const fieldCtx = useFieldContext<string | undefined>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<string | undefined>()

  const merged = useMergedFieldProps({
    fieldCtx,
    editable,
    props,
    fieldDefaults: {
      fieldProps: {
        onChange: (value: unknown, hex?: string) => {
          if (typeof hex === 'string') {
            fieldCtx.handleChange(hex)
            return
          }
          const v = value as { toHexString?: () => string } | string
          if (typeof v === 'string') {
            fieldCtx.handleChange(v)
          } else if (v && typeof v.toHexString === 'function') {
            fieldCtx.handleChange(v.toHexString())
          }
        },
      },
    },
  })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormColorPicker
        {...rest}
        label={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {rest.label}
          </EditableLabel>
        }
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={merged.fieldProps}
      />
    </EditableShell>
  )
}
